import React from "react";
import { FaKey, FaRegCreditCard, FaShippingFast } from "react-icons/fa";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";

const FeatureSection = () => {
  return (
    <LargeContainer style={{ marginTop: "5em" }}>
      <MainContainer halign="space-around">
        <FeatureContainer>
          <FeatureIcon>
            <FaShippingFast />
          </FeatureIcon>
          <FeatureDetails>
            <FeatureHeading>Free Shipping</FeatureHeading>
            <FeatureSubHeading>Capped at $319 per order</FeatureSubHeading>
          </FeatureDetails>
        </FeatureContainer>
        <FeatureContainer>
          <FeatureIcon>
            <FaRegCreditCard />
          </FeatureIcon>
          <FeatureDetails>
            <FeatureHeading>Safe Payment</FeatureHeading>
            <FeatureSubHeading>With our payment gateway</FeatureSubHeading>
          </FeatureDetails>
        </FeatureContainer>
        <FeatureContainer>
          <FeatureIcon>
            <FaKey />
          </FeatureIcon>
          <FeatureDetails>
            <FeatureHeading>Best Services</FeatureHeading>
            <FeatureSubHeading>Friendly and super services</FeatureSubHeading>
          </FeatureDetails>
        </FeatureContainer>
      </MainContainer>
    </LargeContainer>
  );
};
const FeatureContainer = styled.div`
  width: 30%;
  border: 1px dashed #83aa4c;
  padding: 1em;
  display: flex;
  align-items: center;
  border-radius: 0.25em;
`;
const FeatureIcon = styled.div`
  font-size: 3em;
  color: #83aa4c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
`;
const FeatureDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.5rem;
`;
const FeatureHeading = styled.div`
  padding: 0.2rem;
  font-size: 1.2em;
  font-weight: 500;
`;
const FeatureSubHeading = styled.div`
  padding: 0.2rem;
`;
export default FeatureSection;
